export default __webpack_public_path__ + "static/media/spinner.11d9cde8.gif";